module.exports = __webpack_public_path__ + "media/images/main_visual-09c2966911586d4c984d53e15e02abcd.png";